// React
import React, { useState, useEffect } from "react";

// Ionic
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
} from "@ionic/react";

import { scanOutline } from "ionicons/icons";

/*import { useLocation } from 'react-router-dom';*/

// Components

/*** Search ***/
import Map from "../components/Map/Map";
import Markerroute from "../components/Map/MarkerRoute";
//CSS

// Packages
import { Wrapper } from "@googlemaps/react-wrapper";

// Data
import UserService from "../Context/user.service";

//CSS
import RouteSearch from "../components/Route/Route-search";
import InfoCard from "../components/Search/InfoCard";
import ModalBookmark from "../Context/bookmark.modal";

const render = (status) => {
  return <h1>{status}</h1>;
};

window.allRouteMarker = [];

// Function Component Export
function Route(props) {
  function removeAllItems() {
    setItems([]);
  }

  var defaultmode = "customroute";
  var iddef = 0;

  var testurl = window.location.href.split("/route");
  if (testurl[1] !== "" && testurl[1] !== "/") {
    defaultmode = "bookmarkroute";
    var geturl = window.location.href.split("/route/");
    iddef = geturl[1];
    if (iddef.indexOf("sso_session") !== -1) {
      var temp = iddef.split("?sso_session");
      iddef = temp[0];
      if (iddef === "/" || iddef === "") {
        defaultmode = "customroute";
      }
    }

    if (
      typeof window.parent.seturl !== "undefined" &&
      typeof iddef !== "undefined"
    ) {
      window.parent.seturl("route", iddef);
    }
  }

  var userInitial = 1;
  var logedInInitial = false;
  var isProinitial = false;
  var tokenInitial = "";

  const tokenData = UserService.getUserData();
  if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
    userInitial = tokenData["tokenData"].MerchantCustomerId;
    logedInInitial = true;

    if (tokenData.login == 1) {
      logedInInitial = true;
    }
    if (tokenData.pro == 1) {
      isProinitial = true;
    }
    tokenInitial = tokenData.cookie;
  }

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPro, setIsPro] = useState(isProinitial);
  const [isLoggedIn, setIsLoggedIn] = useState(logedInInitial);
  const [user, setUser] = useState(userInitial);
  const [token, setToken] = useState(tokenInitial);
  const [allbookmarks, setAllBookmarks] = useState([]);
  const [searchType, setSearchType] = useState("");
  const [profileInterests, setProfileInterests] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [zoom, setZoom] = useState(9); // initial zoom
  const [mapTypeId, setmapTypeId] = useState("roadmap"); // initial zoom
  const [items, setItems] = useState([]);
  const [mode, setMode] = useState(defaultmode);
  const [id, setId] = useState(iddef);
  const [minimalData, setMinimalData] = useState([]);
  const [bookmark, setbookmark] = useState([]);

  const [center, setCenter] = useState({
    lat: 51.125732475473455,
    lng: 10.099784125401262,
  });
  const pid = user;

  var defaultValueFilter = {
    features: [],
    underground: [],
    searchinput: "",
    price: { lower: 0, upper: 30 },
    vehicle_length: { lower: 4, upper: 15 },
    noofpitches: { lower: 1, upper: 40 },
  };

  /*************************  MAPS HANDLERS ************************* */
  const onClick = (e) => {
    // avoid directly mutating state
    setMarkers([...markers, e.latLng]);
  };

  const onLoad = function (m) {};

  const onIdle = (m) => {};

  const setMapCenter2 = (items) => {
    var bounds = new window.google.maps.LatLngBounds();
    items.forEach((item) => {
      var cords = new window.google.maps.LatLng(
        item.gps.latitude,
        item.gps.longitude
      );
      bounds.extend(cords);
    });
    window.gmap.fitBounds(bounds);

    if (items.length == 1) {
      setCenter(window.gmap.getCenter());
    }
  };

  if (
    typeof window.parent.seturl !== "undefined" &&
    window.self.location.href.indexOf("home") !== -1
  ) {
    setTimeout(function () {
      window.parent.seturl("search", "");
    }, 350);
  }

  function renderRoute(response, type) {
    //setMapCenter(response.data);

    var max = response.data.length - 1;

    if (
      typeof window.directionsRenderer !== "undefined" &&
      window.directionsRenderer !== null
    ) {
      window.directionsRenderer.setMap(null);
    }

    var directionsService = new window.google.maps.DirectionsService();
    var directionsRenderer = new window.google.maps.DirectionsRenderer({
      suppressMarkers: true,
    });
    var waypts: window.google.maps.DirectionsWaypoint = [];
    var start = new window.google.maps.LatLng(
      response.data[0].gps.latitude,
      response.data[0].gps.longitude
    );
    var end = new window.google.maps.LatLng(
      response.data[max].gps.latitude,
      response.data[max].gps.longitude
    );

    window.directionsRenderer = directionsRenderer;

    directionsRenderer.setMap(window.gmap);

    if (max > 1) {
      response.data.forEach((item, index) => {
        if (
          index !== 0 &&
          index !== max &&
          typeof response.data[index].gps !== "undefined"
        ) {
          waypts.push({
            location: new window.google.maps.LatLng(
              response.data[index].gps.latitude,
              response.data[index].gps.longitude
            ),
            stopover: true,
          });
        }
      });
    }

    var request = {
      origin: start,
      destination: end,
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: "DRIVING",
    };
    directionsService.route(request, function (response, status) {
      var markersitems = [];
      var markersinside = [];

      if (status == "OK") {
        if (mode === "customroute") {
          var idstocatch = [];

          /*start*/
          markersitems.push({
            id: "start",
            stellplatzname: "Start",
            stellplatztyp: "start",
            gps: {
              latitude: start.lat,
              longitude: start.lng,
            },
          });
          /*end*/
          markersitems.push({
            id: "destination",
            stellplatzname: "Ziel",
            stellplatztyp: "destination",
            gps: {
              latitude: end.lat,
              longitude: end.lng,
            },
          });

          var nearbys = [];

          response.routes[0].overview_path.forEach((points) => {
            for (const element in minimalData["data"]) {
              var distance = calcDistance(
                minimalData["data"][element].lat,
                points.lat(),
                minimalData["data"][element].lng,
                points.lng()
              );

              if (distance <= 15) {
                // können wir statt mit markersinside nicht mit idstocatch arbeiten?
                if (
                  markersinside.indexOf(minimalData["data"][element].id) ===
                  -1
                ) {
                  markersitems.push({
                    id: minimalData["data"][element].id,
                    stellplatzname: minimalData["data"][element].title,
                    stellplatztyp: minimalData["data"][element].t,
                    gps: {
                      latitude: minimalData["data"][element].lat,
                      longitude: minimalData["data"][element].lng,
                    },
                  });
                  markersinside.push(minimalData["data"][element].id);
                  idstocatch.push(minimalData["data"][element].id);
                }
              }
            }
          });

          UserService.getIDsContent(idstocatch.join(",")).then(
            (response) => {
              removeAllItems();

              // hier ist die Performancebremse
              console.log(response.data.data);
              setItems(response.data.data);

              setTimeout(function () {
                setMapCenter2(response.data.data);
              }, 350);
            },
            (error) => {}
          );
        }
        directionsRenderer.setDirections(response);
      }
    });
    if (mode === "customroute") {
    } else {
      setItems(response.data);
    }
  }

  const calcDistance = function (lat1, lat2, lon1, lon2) {
    lat1 = (lat1 * Math.PI) / 180;
    lat2 = (lat2 * Math.PI) / 180;
    lon1 = (lon1 * Math.PI) / 180;
    lon2 = (lon2 * Math.PI) / 180;
    var R = 6371; // km
    var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    var y = lat2 - lat1;
    var d = Math.sqrt(x * x + y * y) * R;
    return d;
  };

  const getCustomRoute = function (from, to) {
    UserService.getCustomRouteContent(from, to, token).then(
      (response) => {
        if (typeof response.data["error"] !== "undefined") {
          alert(response.data["error"]);
        } else {
          setIsLoaded(true);
          setTimeout(function () {
            renderRoute(response, "custom");
          }, 150);
        }
      },
      (error) => {
        setError(error);
      }
    );
  };

  /*************************  GET PREVIOUS SEARCH + BOOMARK + FILTER DATA ON LOAD************************* */
  useEffect(() => {

    UserService.getBookmarks(pid, token).then(
        (response) => {
          setbookmark(response.data);

          var allb = [];
          response.data.lists.forEach((list) => {
            list.items.forEach((item) => {
              if (typeof item === "number") {
                allb.push(item);
              }
            });
          });

          setAllBookmarks(allb);
        },
        (error) => {
          setError(error);
        }
    );


    if (mode === "bookmarkroute") {
      UserService.getRouteContent(id, pid, token).then(
        (response) => {
          setIsLoaded(true);
          setTimeout(function () {
            renderRoute(response, "bookmarks");
          }, 150);
        },
        (error) => {
          setError(error);
        }
      );
    } else {
      UserService.getMinimalData().then(
        (minData) => {
          setMinimalData(minData.data);
          window.minData = minData.data;
          setIsLoaded(true);
        },
        (error) => {
          console.log(error);
        }
      );

      setIsLoaded(true);
    }
  }, []);

  if (isLoaded && !isPro) {
    if (typeof window.parent.setPaywallModal !== "undefined") {
      window.parent.setPaywallModal("pro");
    }
    return (
      <>
        <IonRow size="12" className="ion-justify-content-center">
          <h2>Routenplanung</h2>
        </IonRow>
        <IonRow size="12" className="ion-justify-content-center">
          <p> Bitte loggen Sie sich ein um diese Funktion zu nutzen.</p>
        </IonRow>
      </>
    );
  }
  /* FULL WIDTH MOBILE MAP */
  const handlefullWidthMap = () => {
    let mapWrapper = document.querySelector(".search__maps");
    mapWrapper.classList.toggle("fullwidth");
  };

  return isLoaded && isPro ? (
    <IonPage
      className={`${isLoggedIn ? "is-logged-in" : "not-logged-in"} ${
        isPro ? "is-pro" : "not-pro"
      }`}
    >

      <ModalBookmark
          isLoggedInValue={isLoggedIn}
          isProValue={isPro}
          pid={pid}
          bookmark={bookmark}
          setbookmark={setbookmark}
          token={token}
      />

      <IonContent fullscreen>
        {(function () {
          if (mode === "customroute") {
            return (
              <RouteSearch
                getCustomRoute={getCustomRoute}
                pid={pid}
                token={token}
              ></RouteSearch>
            );
          }
        })()}
        <IonButton
                    shape="round"
                    color="primary"
                    id="fullWidthMap"
                    onClick={() => handlefullWidthMap()}
                    className="fullWidthMap"
                  >
                    <IonIcon icon={scanOutline} color="light" />
                  </IonButton>

        <IonGrid>
          <IonRow>
            <IonCol className="search__maps" size="12" size-md="6" size-lg="8">
              <div style={{ display: "flex", height: "100%" }}>
                <Wrapper
                  apiKey={"AIzaSyA_F83EK6cz_LUYSGUSCdcmLDZja7Dk0ho"}
                  render={render}
                >
                 
                  <Map
                    id="mainmap"
                    center={center}
                    onClick={onClick}
                    onIdle={onIdle}
                    onLoad={onLoad}
                    zoom={zoom}
                    style={{ flexGrow: "1", height: "100%" }}
                    mapTypeId={mapTypeId}
                  >
                    {items.map((item) => (
                      <Markerroute
                        position={{
                          lat: parseFloat(item.gps.latitude),
                          lng: parseFloat(item.gps.longitude),
                        }}
                        id={item.id}
                        name={item.stellplatzname}
                        marker={item.stellplatztyp}
                      />
                    ))}
                  </Map>
                </Wrapper>
              </div>
            </IonCol>
            <IonCol
              className="search__infocard"
              size="12"
              size-md="6"
              size-lg="4"
            >
              {items.map((item) => {
                if (
                  typeof item.features === "undefined" ||
                  item.features === null
                ) {
                  item.features = {
                    feature: [],
                  };
                }

                var fav = false;
                if (allbookmarks.indexOf(item.id) !== -1) {
                  fav = true;
                }

                if (typeof item.place === "undefined") {
                  item.place = { maxLengthOfPitches: "" };
                }
                if (typeof item.search === "undefined") {
                  item.search = { price: "" };
                }
                if (typeof item.basicCosts === "undefined") {
                  item.basicCosts = { currency: "" };
                }
                if (typeof item.vouchers === "undefined") {
                  item.vouchers = { voucher: [] };
                }
                if (typeof item.prices === "undefined") {
                  item.prices = { generalPrice: "" };
                }

                return (
                  <>
                    <InfoCard
                      key={item.id}
                      id={item.id}
                      name={item.stellplatzname}
                      url={item.mainimage}
                      description={item.description}
                      latitude={parseFloat(item.gps.latitude)}
                      longitude={parseFloat(item.gps.longitude)}
                      distance={parseFloat(item.distance)}
                      stellplaetzeLaenge={item.place.maxLengthOfPitches}
                      vergleichspreis={item.search.price}
                      preiseWaehrung={item.basicCosts.currency}
                      voucher={item.vouchers.voucher}
                      ausstattung={item.features.feature}
                      premium={item.premium}
                      fav={fav}
                      city={item.city}
                      country={item.countryName}
                      responseType={searchType}
                      stellplatztyp={item.stellplatztyp}
                      entsorgungsstation={item.entsorgungsstation}
                      interests={profileInterests}
                      category={item.category}
                      subcategories={item.subcategories}
                      interesttags={item.tags}
                      labelpreis={item.prices.generalPrice}
                    />
                  </>
                );
              })}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  ) : (
    <></>
  );
}

export default Route;
